<template>
  <div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <tl-header type="h1">
      <div>Employee Categories</div>
    </tl-header>
    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
      You have only view permission.
    </div>
    <div class="noData" v-show="ifTeamleaderPermission">
      <span class="text">Click on ‘Add New’ to add new Employee Categories in the following list</span>
      <div>
        <button class="addnewbtn" v-if="empCategoryData.length>3" @click="addNewCategory()">
          <img src="@/assets/group-5.svg" class="add-image" />
          <b>Add New</b>
        </button>
      </div>
    </div>
    <div :disabled="!(ifTeamleaderPermission)">
      <data-table
        :columns="empColumnNames"
        :tableData="empCategoryData"
        :checkbox="false"
        :withForm="false"
        :showhistory="false"
        @editStart="initEditStart"
        @delete="deleteItem"
      >
        <template v-slot:rowcontent="slotprops">
          <div
            v-if="slotprops.value.column.key=='name'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</div>

          <div v-if="slotprops.value.column.key=='subCategory'">
            <div
              v-for="(subcategory,index) of slotprops.value.record[slotprops.value.column.key]"
              :key="index"
            >
              {{subcategory.name}}
              <span
                v-if="!(slotprops.value.record[slotprops.value.column.key].length-1 ==  index)"
              >,</span>
            </div>
          </div>

          <div
            v-if="slotprops.value.column.key=='description'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</div>
        </template>
      </data-table>
    </div>
    <form-add-button
      v-if="empCategoryData.length<=3"
      main_text="+ Add New"
      sub_text="Category"
      @click="addNewCategory()"
      v-show="ifTeamleaderPermission"
    ></form-add-button>

    <pop-up-message
      v-if="showConfirmDelete"
      :message="'Are you sure you want to delete ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Delete'"
    >
      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
          <popup-btn text="Delete" type="primary" @click="deleteEvent" />
        </btn-grp>
      </template>
    </pop-up-message>

    <bottom-action-container>
      <btn-skip @navClicked="continuee"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="previous" />
          <btn text="Next" type="primary" @click="continuee" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { defaultCoreCipherList } from "constants";
export default {
  name: "Bands",
  props: {
    showUpdated: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("onboard/empCategory", {
      empCategoryData: state => state.data
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),

    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    isLoading() {
      return this.isFetching;
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.empCatAndSubCatValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.empCatAndSubCatValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  mounted(){
    this.getOrgLeIdList();
  },
  activated() {
    this.fetchAllCategories();
    this.getOrgLeIdList();
  },
  data() {
    return {
      popupType: "ConfirmDelete",
      currentObj: {},
      showConfirmDelete: false,
      errmsg: "",
      toast: false,
      empColumnNames: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Sub Categories",
          key: "subCategory"
        },
        {
          label: "Description",
          key: "description"
        }
      ],
      empCatAndSubCatValue: false,
      role: ""
    };
  },

  methods: {
    ...mapActions("onboard/empCategory/", {
      fetchAll: "fetchAll",
      act_changeEditMode: "changeEditMode",
      act_delete: "delete"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /* server call to get employee categories */
    async fetchAllCategories() {
      try {
        let res = await this.fetchAll(this.le_id);

      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },


    /* function to go to create an employee category page */
    async addNewCategory() {
      await this.act_changeEditMode({ editMode: false, record: {} });
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/addEmpCategory`
      });
    },

    /* function to go to edit an employee category(create employee category page) */
    async initEditStart(record) {
      try {
        await this.act_changeEditMode({ editMode: true, record: record });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/modifyEmpCategory`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to open delete confirmation pop-up */
    deleteItem(item) {
      try {
        this.showConfirmDelete = true;
        this.currentObj = item;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to hide delete confirmation pop-up */
    cancelEvent() {
      this.showConfirmDelete = false;
    },

    /* server call to delete an employee category */
    async deleteEvent() {
      try {
        let res = await this.act_delete(this.currentObj);
        if (res.status == 200) {
          this.showConfirmDelete = false;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to go to next page */
    continuee() {
      this.$router.push(
        `/onboarding/entity/${this.$route.params.entity_index}/bands`
      );
    },

    /* function to go back to previous page */
    previous() {
      this.$router.push(
        `/onboarding/entity/${this.$route.params.entity_index}/grades`
      );
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.empCatAndSubCatValue = data.data.user.permissions.emp_cat_and_sub_cat ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/form.scss";
.noData {
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
    width: 90%;
  }
}
.addnewbtn b {
  color: #34c0be;
  margin-left: 8px;
  display: flex;
  height: 20px;
  align-items: center;
  float: right;
  .add-image {
    height: 20px;
    width: 20px;
  }
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
